import React from 'react-dom';
import { Link } from 'react-router-dom';
import { NewTabLink } from 'shared/components/abstract/interactables';

/**
 * @param {Object} props
 * @param {Array<Object>} props.links
 * @param {string} props.links[].link
 * @param {boolean} props.links[].newTab
 * @param {Function} [props.links[].skipWhen]
 * @param {string} [props.links[].text]
 */
export default function LinkFormatter(props) {
  const { links } = props;

  return links
    .filter((link) => !link.skipWhen || !link.skipWhen(link))
    .map(({ text, link, newTab }) => (
      <div key={link}>
        {newTab ? <NewTabLink link={link} text={text} /> : <Link to={link}>{text}</Link>}
      </div>
    ));
}
